import { render } from "./ReportInvoices.vue?vue&type=template&id=46789449&scoped=true&ts=true"
import script from "./ReportInvoices.vue?vue&type=script&lang=ts"
export * from "./ReportInvoices.vue?vue&type=script&lang=ts"

import "./ReportInvoices.vue?vue&type=style&index=0&id=46789449&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46789449"]])

export default __exports__